import { render, staticRenderFns } from "./ModalResgateIndicacao.vue?vue&type=template&id=45b73a40"
import script from "./ModalResgateIndicacao.vue?vue&type=script&lang=js"
export * from "./ModalResgateIndicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports